import React from 'react'
import { ErrorMessage } from 'formik'
import { FormattedMessage } from 'react-intl'
import Checkbox from '@iui-kit/components/Checkbox'
import BEM from '@iui-kit/utils/bem'
import { CONSENT_LINK } from '@src/constants/AdvertisingBriefs/urls'
import { AGREEMENT } from '@src/constants/AdvertisingBriefs/Search/fieldNames'
import { FormValues } from '@src/types/BriefSearch/formikProps'
import { createTermLink } from '@src/utils/createTermLink'

const bem = new BEM(require('./Agreement.css'))

interface Props {
  values: FormValues
  isValid: boolean
  handleChange: (e: React.ChangeEvent) => void
  handleBlur: (e: React.FocusEvent) => void
}

const Agreement: React.FC<Props> = props => {
  const { values, isValid, handleChange, handleBlur } = props
  return (
    <div className={bem.b('Agreement').show()}>
      <Checkbox
        name={AGREEMENT}
        isValid={isValid}
        onChange={handleChange}
        onBlur={handleBlur}
        checked={values[AGREEMENT]}
      >
        <FormattedMessage
          id="Brief.search.agreement"
          values={{
            actionTerm: (
              <a href={createTermLink(values.platform)} target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="Brief.search.agreement.actionTerm" />
              </a>
            ),
            consent: (
              <a href={CONSENT_LINK} target="_blank" rel="noopener noreferrer">
                <FormattedMessage id="Brief.search.agreement.consent" />
              </a>
            )
          }}
        />
      </Checkbox>
      <ErrorMessage
        className={bem
          .b('Agreement')
          .e('error')
          .show()}
        component="span"
        name={AGREEMENT}
      />
    </div>
  )
}

export default Agreement
